// Department picker for host forms (PB-18-07, PD-541): active department references only; the API
// refuses an inactive or unknown one.
import type { DepartmentDto } from '@passage/contracts';
import { useQuery } from '@tanstack/react-query';
import { get } from '../api.ts';
import { useI18n } from '../i18n.tsx';
import { useSession } from '../session.tsx';
import { Field } from './ui.tsx';

export function DepartmentSelect({ id, value, onChange, siteId }: { id: string; value: string; onChange: (id: string) => void; siteId?: string | null }) {
  const { t } = useI18n();
  const { scopeKey } = useSession();
  const q = useQuery({ queryKey: [...scopeKey, 'departments', 'active', siteId ?? ''], queryFn: () => get<{ items: DepartmentDto[] }>(`/api/v1/departments${siteId ? `?siteId=${siteId}` : ''}`) });
  return (
    <Field id={id} label={t('mdl.dep.pick')} hint={t('mdl.dep.pickHint')}>
      {(p) => (
        <select {...p} value={value} onChange={(e) => onChange(e.target.value)} disabled={q.isPending}>
          <option value="">{t('mdl.dep.pickNone')}</option>
          {(q.data?.items ?? []).map((d) => (
            <option key={d.id} value={d.id}>
              {d.name}
            </option>
          ))}
        </select>
      )}
    </Field>
  );
}
